import React from 'react'



import { useAppSelector } from '../../../hooks/redux'
import { type RootState } from '../../../store/store'

import SchedulerNavigateNewVersion from './scheduleNavigate/SchedulerNavigateNewVersion'

interface IProps {
    allAttention: any
    countView: number
    countOffers: number
    advertisesCount: number
    broadcastMessagesCount: number
    viewingsNotifies: number
    offersNotifies: number
    advertisesNotifies: number
    portalRequestsCount: number
    portalRequestsNotifies: number
    agentActivityCount: number
    isDesktop: boolean
}

export default function SchedulerHeader({
    allAttention,
    countView, countOffers, advertisesCount, broadcastMessagesCount,
    viewingsNotifies,
    offersNotifies,
    advertisesNotifies,
    portalRequestsCount,
    portalRequestsNotifies,
    agentActivityCount,
    isDesktop
}: IProps): JSX.Element {
    const userDevice = useAppSelector((state) => state.app.userDevice)
    const { isShown } = useAppSelector((state: RootState) => state.voice)
    return (
        <div
            className="scheduler-header position-fixed w-100 bg-white h-auto fw-bold d-flex flex-column shadow-sm"
            style={{
                top: isShown ? '31px' : 0,
                left: 0,
                right: 0,
                zIndex: 101
            }}
        >
            <div className="scheduler-header__inner schedule-page__inner d-flex flex-column p-4 py-0 w-100 position-relative">

                {/* <AgentHeader active={isMyTasks ? 'My Units Scheduler' : 'Schedule'}
                    allAttention={allAttention}
                    notifyApp={notifyApp}
                    viewingsNotifiesOtherAgents={viewingsNotifiesOtherAgents}
                    isBSOUnits={isBSOUnits} setIsBSOUnits={setIsBSOUnits}
                /> */}
                {userDevice === 'IPhone'
                    ? <div className="h-25px"></div>
                    : <></>
                }
                <SchedulerNavigateNewVersion countView={countView}
                    countOffers={countOffers}
                    countAdvertises={advertisesCount}
                    broadcastMessagesCount={broadcastMessagesCount}
                    viewingsNotifies={viewingsNotifies}
                    offersNotifies={offersNotifies}
                    advertisesNotifies={advertisesNotifies}
                    portalRequestsCount={portalRequestsCount}
                    portalRequestsNotifies={portalRequestsNotifies}
                    agentActivityCount={agentActivityCount}
                    allAttention={allAttention}
                    isDesktop={isDesktop}

                />

            </div>
        </div>
    )
}
